import cx from 'classnames'
import React from 'react'

import { ProfileV2 } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import { GRADIENT_IDS } from '@cinch/oxd-components/svg/src'

import styles from './user-avatar.module.css'

const bravoGradientFill = `url(#${GRADIENT_IDS.bravo})`

const AVATAR_SIZE = '140px'
const AVATAR_SIZE_SMALL = '60px'

interface Props {
  picture?: string
  alt?: string
  isSmall?: boolean
  additionalClass?: string
}

const UserAvatar: React.FC<Props> = ({ picture, alt, isSmall = false, additionalClass }) => {
  const svgSize = isSmall ? AVATAR_SIZE_SMALL : AVATAR_SIZE
  const className = cx(styles.avatar, additionalClass, { [styles.small]: isSmall })

  return picture && picture.length ? (
    <img className={className} src={picture} alt={alt} data-testid="avatar-image" />
  ) : (
    <SVG className={className} children={ProfileV2} fill={bravoGradientFill} size={svgSize} data-testid="avatar-svg" />
  )
}

export default UserAvatar
